// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"151":"b472bc71","314":"9ab47b4e"}[chunkId] + ".chunk.css";
};